import {z} from 'zod';

const BUILD = z.string().min(1);

export const BuildEnvsSchema = z.object({
	NODE_ENV: z.enum(['development', 'production']).optional().default('production'),
	BUILD,
});

// TODO: Remove it when ops-plan-state provide correct values!
function mustNotHaveTrailingSlash(v: string, ctx: z.RefinementCtx) {
	const sanitized = v.replace(/\/$/iu, '');
	if (sanitized.length > 0) {
		return sanitized;
	}
	ctx.addIssue({
		code: z.ZodIssueCode.custom,
		message: 'Must not have trailing slash and should not be an empty string!!',
	});
	return z.NEVER;
}

export const ClientEnvsSchema = z.object({
	APP_PREFIX: z
		.string()
		.startsWith('/', {message: 'Must have leading and trailing slashes!!'})
		.endsWith('/', {message: 'Must have leading and trailing slashes!!'}),
	BUILD,
	CLIENT_AUTH: z
		.string()
		.startsWith('/', {message: 'Must have leading and trailing slashes!!'})
		.endsWith('/', {message: 'Must have leading and trailing slashes!!'})
		.optional()
		.default('/auth-client/'),
	FEATURES: z.string().optional(),
	GOOGLE_ANALYTICS_ID: z.string(),
	GOOGLE_MAPS_API_KEY: z.string(),
	GOOGLE_TAG_MANAGER_AUTH: z.string(),
	GOOGLE_TAG_MANAGER_CONTAINER: z.string(),
	GOOGLE_TAG_MANAGER_PREVIEW: z.string(),
	GRAFANA_FARO_APP_URL: z.string().optional(),
	PROPAGATE_TRACE_HEADER_URL: z.string().optional(),
	SERVICE_API_V1: z.string().url().transform(mustNotHaveTrailingSlash),
	// .url().regex(/[^/]$/u, {message: 'Must not have trailing slash!!'}),
	SERVICE_API_V2: z.string().url().transform(mustNotHaveTrailingSlash),
	// .url().regex(/[^/]$/u, {message: 'Must not have trailing slash!!'}),
	SERVICE_AUTH: z.string().url().transform(mustNotHaveTrailingSlash),
	// .url().regex(/[^/]$/u, {message: 'Must not have trailing slash!!'}),
	SERVICE_ORGANIZATION_URL: z.string().url().transform(mustNotHaveTrailingSlash),
	// .url().regex(/[^/]$/u, {message: 'Must not have trailing slash!!'}),
	SERVICE_CORE_GRAPHQL: z.string().url(),
	SERVICE_API_GRAPHQL: z.string().url(),
});

export const DevEnvsSchema = z.object({
	PORT: z.union([z.string(), z.number()]).transform(Number).default(3456),
	DEV_SERVER_ALLOWED_HOSTS: z
		.string()
		.optional()
		.transform((v) => v?.split(',')?.map((s) => s?.trim())),
	DEV_SERVER_HOST: z.string().ip().optional().default('0.0.0.0'),
});

export type BuildEnvs = z.infer<typeof BuildEnvsSchema>;
export type ClientEnvs = z.infer<typeof ClientEnvsSchema>;
export type DevEnvs = z.infer<typeof DevEnvsSchema>;
